const BYTE_UNITS = ["B", "KB", "MB", "GB", "TB"];

export function formatBytes(bytes: number | bigint): string {
    const n = typeof bytes === "bigint" ? Number(bytes) : bytes;
    if (!n || !Number.isFinite(n) || n <= 0) return "0 B";
    const i = Math.min(Math.floor(Math.log(n) / Math.log(1024)), BYTE_UNITS.length - 1);
    const value = n / Math.pow(1024, i);
    const decimals = i >= 3 ? 2 : i >= 2 ? 1 : 0;
    return `${value.toFixed(decimals)} ${BYTE_UNITS[i]}`;
}
